import React, { useEffect, useState } from "react";
import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import Modal from "../../components/Modal/Modal";
import formFields from "../../config/formFields.json";
import {
  StyledDialog,
  StyledDialogTitle,
  HeaderContainer,
  IconContainer,
} from "./EditUserStyles";
import { useLoading } from "../../contexts/LoadingContext";
import FormValidation from "../../components/FormValidation/FormValidation";

const EditUser = ({
  open,
  onClose,
  initialData = null,
  onSubmit,
  userAccessManagement = [],
}) => {
  const isEdit = !!initialData;
  const { showLoading, hideLoading } = useLoading();
  const [formData, setFormData] = useState({ role_id: "" });
  const [errorModal, setErrorModal] = useState(null);

  const getOptionsForField = (key) => {
    if (key === "role_id") {
      const opts =
        (userAccessManagement || []).map((r) => ({
          value: String(r.role_id),
          label: r.role_name,
        })) ?? [];
      return opts;
    }
    return [];
  };

  useEffect(() => {
    if (!open) {
      setFormData({ role_id: "" });
      setErrorModal(null);
      return;
    }
    if (initialData) {
      setFormData({
        role_id:
          initialData?.role_id !== undefined && initialData?.role_id !== null
            ? String(initialData.role_id)
            : "",
      });
    } else {
      setFormData({ role_id: "" });
    }
  }, [open, initialData]);

  const handleSubmit = async (payload) => {
    try {
      showLoading();
      const res = await onSubmit(payload);
      return res;
    } catch (e) {
      return { success: false, error: e?.message || "Something went wrong" };
    } finally {
      hideLoading();
    }
  };

  const handleClose = () => {
    setFormData({ role_id: "" });
    setErrorModal(null);
    onClose();
  };

  return (
    <>
      <StyledDialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <StyledDialogTitle>
          <HeaderContainer>
            <IconContainer>
              <BusinessIcon />
              <Typography variant="h6">Access Permissions</Typography>
            </IconContainer>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </HeaderContainer>
        </StyledDialogTitle>

        <FormValidation
          modelWidth={"60vw"}
          open={open}
          onClose={handleClose}
          initialData={formData}
          onSubmit={handleSubmit}
          formFields={formFields.userAccessManagement.basic.fields}
          title="Access Permissions"
          icon={BusinessIcon}
          isEdit={isEdit}
          moduleName="userAccessManagement"
          getOptionsForField={getOptionsForField}
        />
      </StyledDialog>

      {errorModal && (
        <Modal
          type={errorModal.type}
          title={errorModal.title}
          message={errorModal.message}
          onClose={() => setErrorModal(null)}
        />
      )}
    </>
  );
};

export default EditUser;
